import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  DataGrid,
  GridToolbarQuickFilter,
  GridLinkOperator,
  gridClasses,
} from "@mui/x-data-grid";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import FormControl from "@mui/material/FormControl";
import GridItemLogin from "components/Grid/GridItemLogin.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeadertab.js";
import CloseIcon from "@mui/icons-material/Close";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import Themlaixe from "components/Danhmuc/Laixe/Themlaixe.js";
import Capnhatlaixe from "components/Danhmuc/Laixe/Capnhatlaixe.js";
import dayjs from "dayjs";
import Config from "conFig.js";
import styles from "assets/jss/material-dashboard-react/components/tableviewStyle.js";
const useStyles = makeStyles(styles);
const datagridSx = {
  [`& .${gridClasses.cell}`]: {
    py: 1,
  },
  [`& .center`]: {
    justifyContent: "center !important",
  },
  borderRadius: 2,
  "& .MuiDataGrid-main": { borderRadius: 2 },
  "& .MuiDataGrid-virtualScrollerRenderZone": {
    "& .MuiDataGrid-row": {
      "&:nth-of-type(2n)": { backgroundColor: "rgba(235, 235, 235, .7)" },
    },
  },
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "rgba(0,0,255,0.6)",
    color: "rgb(255 255 255)",
    fontSize: 16,
  },
  "& .MuiInputBase-root": {
    height: "25px",
  },
};
const lxcolumn = [
  {
    field: "stt",
    headerName: "STT",
    width: 80,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "donvi",
    headerName: "Đơn vị chủ quản",
    width: 300,
    headerAlign: "center",
  },
  {
    field: "hoten",
    headerName: "Họ tên",
    width: 180,
    headerAlign: "center",
  },
  {
    field: "ngaysinh",
    headerName: "Ngày sinh",
    width: 130,
    headerAlign: "center",
    valueFormatter: (params) => dayjs(params.value).format("DD/MM/YYYY"),
  },
  {
    field: "diachi",
    headerName: "Địa chỉ",
    width: 220,
    headerAlign: "center",
  },
  {
    field: "sodienthoai",
    headerName: "Số điện thoại",
    width: 140,
    headerAlign: "center",
  },
  {
    field: "cmnd",
    headerName: "CMND/CCCD",
    width: 130,
    headerAlign: "center",
  },
  {
    field: "ngaycapcmnd",
    headerName: "Ngày cấp CMND/CCCD",
    width: 180,
    headerAlign: "center",
  },
  {
    field: "sogiaypheplaixe",
    headerName: "Số giấy phép",
    width: 160,
    headerAlign: "center",
  },
  {
    field: "hanggiaypheplaixe",
    headerName: "Hạng GPLX",
    width: 160,
    headerAlign: "center",
  },
  {
    field: "ngayhethangplx",
    headerName: "Ngày hết hạn GPLX",
    width: 160,
    headerAlign: "center",
    valueFormatter: (params) => dayjs(params.value).format("DD/MM/YYYY"),
  },
  {
    field: "giaykhamsuckhoe",
    headerName: "Giấy khám sức khỏe",
    width: 160,
    headerAlign: "center",
  },
  {
    field: "hopdonglaodong",
    headerName: "Hợp đồng lao động",
    width: 160,
    headerAlign: "center",
  },
];
export default function Thongtinlaixe() {
  const classes = useStyles();
  const [pageSize, setPageSize] = React.useState(50);
  const [laixe, setLaixe] = React.useState([]);
  const [laixe_id, setLaixe_id] = React.useState(0);
  const [openthem, setOpenthem] = React.useState(false);
  const [opencapnhat, setOpencapnhat] = React.useState(false);
  const [disableBT, setDisableBT] = React.useState(true);
  const [alert, setAlert] = React.useState(false);
  const handleClose = () => {
    setOpenthem(false);
    getlaixe();
  };
  const handleClosecapnhat = () => {
    setOpencapnhat(false);
    getlaixe();
  };
  const openthempt = () => {
    setOpenthem(true);
  };
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const getlaixe = () => {
    var url =
      Config.backend + "/api/Donvi/getlaixetheouser?username=" + username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setLaixe(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const quickSearchToolbar = () => {
    return (
      <Box
        sx={{
          p: 0.5,
          pb: 0,
        }}
      >
        <GridToolbarQuickFilter
          quickFilterParser={(searchInput: string) =>
            searchInput
              .split(",")
              .map((value) => value.trim())
              .filter((value) => value !== "")
          }
          placeholder="Tìm kiếm"
        />
      </Box>
    );
  };
  const xoalaixe = () => {
    var url = Config.backend + "/api/Donvi/xoalaixe";
    fetch(url, {
      method: "DELETE",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        id: laixe_id,
        username: username,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data === 1) {
          showNotification();
          getlaixe();
          setDisableBT(true);
        }
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const openlink = () => {
    window.open("https://gplx.csgt.bocongan.gov.vn/");
  };
  const showNotification = () => {
    setAlert(true);
    setTimeout(function () {
      setAlert(false);
    }, 2000);
  };
  React.useEffect(() => {
    getlaixe();
  }, []);
  return (
    <GridContainer>
      <GridItem xs={12} sm={10} md={12} style={{ marginTop: 5 }}>
        <FormControl style={{ width: "12%" }}>
          <Button
            color="primary"
            variant="contained"
            onClick={openthempt}
            style={{ height: 27 }}
          >
            Thêm mới
          </Button>
        </FormControl>
        <FormControl style={{ width: "10%", marginLeft: 10 }}>
          <Button
            color="error"
            variant="contained"
            disabled={disableBT}
            style={{ height: 27 }}
            onClick={xoalaixe}
          >
            Xóa
          </Button>
        </FormControl>
        <FormControl style={{ width: "14%", marginLeft: 10 }}>
          <Button
            color="warning"
            variant="contained"
            style={{ height: 27 }}
            onClick={openlink}
          >
            Tra cứu GPLX
          </Button>
        </FormControl>
      </GridItem>
      <GridItem xs={12} sm={10} md={12} style={{ marginTop: 10 }}>
        <div style={{ height: 500, width: "100%" }}>
          <DataGrid
            getRowId={(row) => row.stt}
            rows={laixe}
            columns={lxcolumn}
            checkboxSelection={false}
            getRowHeight={() => "auto"}
            headerHeight={35}
            onRowClick={(params) => {
              setLaixe_id(params.row.id);
              setDisableBT(false);
            }}
            onCellDoubleClick={(params, event) => {
              if (!event.ctrlKey) {
                setOpencapnhat(true);
              }
            }}
            sx={datagridSx}
            pageSize={pageSize}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[20, 50, 100]}
            pagination
            initialState={{
              filter: {
                filterModel: {
                  items: [],
                  quickFilterLogicOperator: GridLinkOperator.Or,
                },
              },
            }}
            components={{ Toolbar: quickSearchToolbar }}
          />
        </div>
      </GridItem>
      <GridItem xs={12} sm={10} md={12}>
        <Modal
          open={openthem}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div>
            <GridContainer>
              <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
              <GridItemLogin xs={12} sm={12} md={6}>
                <Card>
                  <CardHeader color="primary" style={{ height: 10 }}>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={10}>
                        <FormControl
                          style={{ width: "100%", marginTop: "10px" }}
                        >
                          <h6
                            className={classes.cardTitleWhite}
                            style={{ marginTop: "-5px" }}
                          >
                            Thêm thông tin lái xe
                          </h6>
                        </FormControl>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={1}></GridItem>
                      <GridItem xs={12} sm={12} md={1}>
                        <FormControl
                          style={{ width: "100%", marginTop: "1px" }}
                        >
                          <CloseIcon onClick={handleClose} />
                        </FormControl>
                      </GridItem>
                    </GridContainer>
                  </CardHeader>
                  <Themlaixe />
                </Card>
              </GridItemLogin>
              <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
            </GridContainer>
          </div>
        </Modal>
      </GridItem>
      <GridItem xs={12} sm={10} md={12}>
        <Modal
          open={opencapnhat}
          onClose={handleClosecapnhat}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div>
            <GridContainer>
              <GridItemLogin xs={12} sm={12} md={2}></GridItemLogin>
              <GridItemLogin xs={12} sm={12} md={8}>
                <Card>
                  <CardHeader color="primary" style={{ height: 10 }}>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={10}>
                        <FormControl
                          style={{ width: "100%", marginTop: "10px" }}
                        >
                          <h6
                            className={classes.cardTitleWhite}
                            style={{ marginTop: "-5px" }}
                          >
                            Cập nhật lái xe
                          </h6>
                        </FormControl>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={1}></GridItem>
                      <GridItem xs={12} sm={12} md={1}>
                        <FormControl
                          style={{ width: "100%", marginTop: "1px" }}
                        >
                          <CloseIcon onClick={handleClosecapnhat} />
                        </FormControl>
                      </GridItem>
                    </GridContainer>
                  </CardHeader>
                  <Capnhatlaixe laixe_id={laixe_id} />
                </Card>
              </GridItemLogin>
              <GridItemLogin xs={12} sm={12} md={2}></GridItemLogin>
            </GridContainer>
          </div>
        </Modal>
      </GridItem>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="info"
            icon={AddAlert}
            message="Xóa thành công"
            open={alert}
            closeNotification={() => setAlert(false)}
            close
          />
        </GridItem>
      </GridContainer>
    </GridContainer>
  );
}
